export default {"src":"/_next/static/media/logo.1c7767b2.svg","height":49,"width":227};